import React, { useMemo } from 'react';
import { useAppSelector } from '../../hooks/ReduxHooks';
import { useUserPersistedState } from '../../persistedstate/users/useUserPersistedState';
import GlobalBanner from '../../components/banner/GlobalBanner';
import { canIUse } from '../../helpers/PermissionUtility';
import { AppFeatures } from '../../helpers/PermissionUtility';
import { toggleHipaaSetupModal } from './actions';
import { useDispatch } from 'react-redux';
import { HipaaSetupDispatch, HipaaSetupState } from './hipaa-types';
import { useNavigate } from 'react-router-dom';

export default function HipaaSetupBanner(props: { shouldShow: boolean }) {
  const isHIPAAFeatureFlagEnabled = canIUse(AppFeatures.HIPAASetup);
  const isHIPAAEnabled = useAppSelector<boolean>((state) => state.profile.client.isHIPAA);
  const [persistedHideHipaaBannerState, setPersistedHideHipaaState] = useUserPersistedState('hideHipaaSetupBanner');
  const hipaaSetup = useAppSelector<HipaaSetupState>((state) => state.hipaaSetup);
  const dispatch = useDispatch<HipaaSetupDispatch>();
  const navigate = useNavigate();

  const shouldShowHipaaBanner = useMemo(() => {
    if (isHIPAAFeatureFlagEnabled && !isHIPAAEnabled && persistedHideHipaaBannerState != null) {
      return !persistedHideHipaaBannerState ?? true;
    }
    return false;
  }, [isHIPAAFeatureFlagEnabled, isHIPAAEnabled, persistedHideHipaaBannerState]);

  const onHipaaLinkClick = (event) => {
    event.preventDefault();
    navigate('/settings', { replace: true });

    dispatch(toggleHipaaSetupModal(true));
  };

  const onBannerDismiss = () => {
    setPersistedHideHipaaState(true);
  };

  return (
    <>
      {!hipaaSetup.processed && shouldShowHipaaBanner && props.shouldShow && (
        <GlobalBanner
          message={
            <>
              You need to{' '}
              <a data-testid="hipaa-setup-click" onClick={onHipaaLinkClick}>
                finish the set-up process
              </a>{' '}
              to become HIPAA compliant.
            </>
          }
          handleDismiss={onBannerDismiss}
        />
      )}
    </>
  );
}
